module.exports = __webpack_public_path__ + "assets/park-gorkogo.0738e566c54c8da59b52e99a292bd25a43cc84908e002da47cc6ff0f1d6fe74b.png";